module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_iterators.js
// module id = 366
// module chunks = 2